export const comments_5159998 = {"data":{"data":[],"links":{}}}